'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndexResult = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ImageFrame = require('./ImageFrame');

var _ImageFrame2 = _interopRequireDefault(_ImageFrame);

var _ImagePlaceholderFrame = require('./ImagePlaceholderFrame');

var _ImagePlaceholderFrame2 = _interopRequireDefault(_ImagePlaceholderFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IndexResult = exports.IndexResult = function () {
  function IndexResult(element, args) {
    _classCallCheck(this, IndexResult);

    var div = document.createElement('div');
    div.className = 'contact';
    div.onclick = args.onclick;
    var image = null;

    if (args.showImage !== false) {
      if (args.item && args.item.getImage && args.item.getImage()) {
        image = new _ImageFrame2.default(div, {
          image: args.item.getImage()
        });
      } else {
        image = new _ImagePlaceholderFrame2.default(div, {
          title: args.item ? args.item.getTitle() : null
        });
      }
    }

    var dl = document.createElement('dl');
    this.dt = document.createElement('dt');
    this.dt.innerHTML = args.title;
    this.dd = document.createElement('dd');
    this.dd.innerHTML = args.subtitle;

    dl.appendChild(this.dt);
    dl.appendChild(this.dd);
    div.appendChild(dl);

    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);

    element.appendChild(fragment);
  }

  _createClass(IndexResult, [{
    key: 'getTitle',
    value: function getTitle() {
      return this.dt.innerHTML;
    }
  }, {
    key: 'setTitle',
    value: function setTitle(text) {
      this.dt.innerHTML = text;
    }
  }, {
    key: 'getSubtitle',
    value: function getSubtitle() {
      return this.dd.innerHTML;
    }
  }, {
    key: 'setSubtitle',
    value: function setSubtitle(text) {
      this.dd.innerHTML = text;
    }
  }]);

  return IndexResult;
}();

var IndexList = function () {
  function IndexList(element, args) {
    var _this = this;

    _classCallCheck(this, IndexList);

    this.div = document.createElement('div');
    this.div.className = 'index';
    this.reverse = args.reverse;
    this.showImage = args.showImage;
    this.onclick = args.onclick;
    this.p = document.createElement('p');
    this.input = document.createElement('input');
    this.input.placeholder = 'Typ hier om te filteren';
    this.input.type = 'search';
    this.input.onkeydown = function (e) {
      if (event.keyCode === 13) {
        e.target.blur();
      }
    };
    this.items = [];

    this.input.oninput = function () {
      _this.refreshResults();
    };

    this.setItems(args.items);

    var fragment = document.createDocumentFragment();
    fragment.appendChild(this.div);
    this.div.appendChild(this.input);
    this.div.appendChild(this.p);

    element.appendChild(fragment);
  }

  _createClass(IndexList, [{
    key: 'getFilter',
    value: function getFilter() {
      return this.input.value;
    }
  }, {
    key: 'setFilter',
    value: function setFilter(filter) {
      this.input.value = filter;
      this.refreshResults();
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      return this.items;
    }
  }, {
    key: 'setItems',
    value: function setItems(newItems) {
      var _this2 = this;

      this.div.classList.add('working');
      this.items = newItems;

      new Promise(function (resolve) {
        if (_this2.items) {
          _this2.items.sort(function (item, compareTo) {
            if (item.getCompareString && compareTo.getCompareString) {
              return _this2.reverse ? compareTo.getCompareString().localeCompare(item.getCompareString()) : item.getCompareString().localeCompare(compareTo.getCompareString());
            }

            return 0;
          });

          resolve();
        } else {
          resolve();
        }
      }).then(function () {
        _this2.refreshResults();
        _this2.div.classList.remove('working');
      });
    }
  }, {
    key: 'refreshResults',
    value: function refreshResults() {
      var _this3 = this;

      var filter = this.getFilter().toLowerCase();
      var lastLabel = '';

      if (!this.items || !this.items.length) {
        this.p.innerHTML = 'Geen gegevens beschikbaar';
        this.input.className = 'invisible';
        this.input.disabled = true;
        return;
      }

      this.input.className = '';
      this.input.disabled = false;

      var results = [];

      this.p.innerHTML = '';

      this.items.forEach(function (item) {
        var title = item ? item.getTitle() ? item.getTitle().toLowerCase() : 'onbekend' : '';
        var subtitle = item ? item.getSubtitle() ? item.getSubtitle().toLowerCase() : 'onbekend' : '';

        if (filter && title.indexOf(filter) === -1 && subtitle.indexOf(filter) === -1) {
          return;
        }

        if (lastLabel !== item.getIndex()) {
          lastLabel = item.getIndex();
          var label = document.createElement('label');
          label.innerHTML = lastLabel;
          _this3.p.appendChild(label);
        }

        results.push(new IndexResult(_this3.p, {
          title: item.getTitle(),
          subtitle: item.getSubtitle(),
          item: item,
          showImage: _this3.showImage,
          onclick: function onclick() {
            if (_this3.onclick) {
              _this3.onclick(item);
            }
          }
        }));
      });

      if (filter && !results.length) {
        this.p.innerHTML = 'Filter geeft geen resultaten';
        return;
      }
    }
  }]);

  return IndexList;
}();

exports.default = IndexList;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/IndexControl.js
// module id = 22
// module chunks = 0